import { api } from './client';

export interface TelegramConfig {
  enabled: boolean;
  chatId: string | null;
  hasBotToken: boolean;
}

export interface TelegramPutInput {
  // 명시적 null 또는 빈 문자열은 "제거" 의미.
  botToken?: string | null;
  chatId?: string | null;
  enabled?: boolean;
}

export interface TelegramTestInput {
  // 양쪽 모두 옵션 — 미지정 시 서버 저장값 사용.
  botToken?: string;
  chatId?: string;
}

export const telegramApi = {
  get: () => api.get<TelegramConfig>('/api/admin/telegram'),
  put: (body: TelegramPutInput) => api.put<TelegramConfig>('/api/admin/telegram', body),
  test: (body: TelegramTestInput) => api.post<{ ok: true }>('/api/admin/telegram/test', body),
};
